import React from 'react';
import { StyleProp, ViewStyle } from 'react-native';
import { BaseSkeleton } from './BaseSkeleton';

export type SkeletonOwnProps = {
    style?: StyleProp<ViewStyle>;
    testID?: string;
};

export type SkeletonProps = SkeletonOwnProps;

const Skeleton: React.FC<SkeletonProps> = (props) => {
    return <BaseSkeleton {...props} />;
};

export default React.memo(Skeleton);
